export default __webpack_public_path__ + "static/sync-integrations-6e8cf7ff95930bd0f6b8ca14aef5b20d.mp4";